module.exports = {"TXTWCL_Stake":{"id":"TXTWCL_Stake","defaultMessage":"Mise","track":"Stake"}}